import React from 'react';

export default function Datenschutz({ onBack }) {
  return (
    <div className="font-sans text-gray-900 antialiased min-h-screen bg-white">

      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 bg-white/90 backdrop-blur-md z-50 border-b border-gray-100">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <button onClick={onBack} className="flex items-center gap-2">
              <span className="text-2xl font-black text-teal-700 tracking-tight">Merian.ai</span>
            </button>
            <button
              onClick={onBack}
              className="text-sm font-medium text-gray-600 hover:text-teal-700 transition-colors flex items-center gap-1"
            >
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
              </svg>
              Zurück
            </button>
          </div>
        </div>
      </nav>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-20">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">Datenschutzerklärung</h1>
        <p className="text-sm text-gray-400 mb-10">Stand: 21. August 2026</p>

        {/* 1. Verantwortlicher */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-gray-900 mb-4">1. Verantwortlicher</h2>
          <p className="text-gray-600 leading-relaxed">
            Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:<br /><br />
            LocNet GmbH<br />
            Bussenstraße 5<br />
            88677 Markdorf<br />
            Deutschland<br /><br />
            Telefon: +49 155 699 009 12<br />
            E-Mail: <a href="mailto:app@merian.ai" className="text-teal-700 hover:underline">app@merian.ai</a>
          </p>
        </section>

        {/* 2. Allgemeines */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-gray-900 mb-4">2. Allgemeines zur Datenverarbeitung</h2>
          <p className="text-gray-600 leading-relaxed mb-4">
            Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst und behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
          </p>
          <p className="text-gray-600 leading-relaxed">
            Diese Website erhebt und verarbeitet personenbezogene Daten nur im technisch notwendigen Umfang. Es werden keine Tracking-Tools, Analyse-Dienste oder Social-Media-Plugins von Drittanbietern eingesetzt. Auf dieser Website werden keine Cookies gesetzt.
          </p>
        </section>

        {/* 3. Hosting */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-gray-900 mb-4">3. Hosting</h2>
          <p className="text-gray-600 leading-relaxed mb-4">
            Diese Website wird über <strong>Microsoft Azure Static Web Apps</strong> gehostet. Anbieter ist die Microsoft Corporation, One Microsoft Way, Redmond, WA 98052-6399, USA.
          </p>
          <p className="text-gray-600 leading-relaxed mb-4">
            Wenn Sie unsere Website besuchen, verarbeitet Microsoft automatisch technische Zugriffsdaten in sogenannten Server-Log-Dateien. Dazu gehören:
          </p>
          <ul className="list-disc list-inside text-gray-600 leading-relaxed mb-4 space-y-1">
            <li>IP-Adresse des anfragenden Rechners</li>
            <li>Datum und Uhrzeit des Abrufs</li>
            <li>Name und URL der abgerufenen Datei</li>
            <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
            <li>Verwendeter Browser und ggf. das Betriebssystem</li>
          </ul>
          <p className="text-gray-600 leading-relaxed mb-4">
            Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse). Unser berechtigtes Interesse liegt in der ordnungsgemäßen Bereitstellung der Website sowie der Gewährleistung der Systemsicherheit.
          </p>
          <p className="text-gray-600 leading-relaxed">
            Microsoft ist unter dem EU-U.S. Data Privacy Framework zertifiziert. Weitere Informationen zum Datenschutz bei Microsoft finden Sie unter:{' '}
            <a
              href="https://privacy.microsoft.com/de-de/privacystatement"
              target="_blank"
              rel="noopener noreferrer"
              className="text-teal-700 hover:underline"
            >
              https://privacy.microsoft.com/de-de/privacystatement
            </a>
          </p>
        </section>

        {/* 4. Schriftarten */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-gray-900 mb-4">4. Schriftarten</h2>
          <p className="text-gray-600 leading-relaxed">
            Diese Website verwendet die Schriftart <strong>Inter</strong>, die lokal auf unserem Server gespeichert ist. Es werden keine Verbindungen zu externen Servern (z.B. Google Fonts) hergestellt. Es werden daher keine personenbezogenen Daten an Dritte übertragen.
          </p>
        </section>

        {/* 5. Cookies */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-gray-900 mb-4">5. Cookies</h2>
          <p className="text-gray-600 leading-relaxed">
            Diese Website setzt keine Cookies. Es werden weder technisch notwendige noch optionale Cookies verwendet. Es findet kein Tracking und keine Analyse des Nutzerverhaltens statt.
          </p>
        </section>

        {/* 6. Betroffenenrechte */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-gray-900 mb-4">6. Ihre Rechte als betroffene Person</h2>
          <p className="text-gray-600 leading-relaxed mb-4">
            Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:
          </p>
          <ul className="space-y-3 text-gray-600">
            <li className="flex gap-3">
              <span className="font-semibold text-gray-900 min-w-fit">Auskunft (Art. 15 DSGVO):</span>
              <span>Sie haben das Recht, eine Bestätigung darüber zu verlangen, ob Sie betreffende Daten verarbeitet werden, sowie Auskunft über diese Daten.</span>
            </li>
            <li className="flex gap-3">
              <span className="font-semibold text-gray-900 min-w-fit">Berichtigung (Art. 16 DSGVO):</span>
              <span>Sie haben das Recht, die Berichtigung unrichtiger oder Vervollständigung unvollständiger Daten zu verlangen.</span>
            </li>
            <li className="flex gap-3">
              <span className="font-semibold text-gray-900 min-w-fit">Löschung (Art. 17 DSGVO):</span>
              <span>Sie haben das Recht, die Löschung Ihrer personenbezogenen Daten zu verlangen.</span>
            </li>
            <li className="flex gap-3">
              <span className="font-semibold text-gray-900 min-w-fit">Einschränkung (Art. 18 DSGVO):</span>
              <span>Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer Daten zu verlangen.</span>
            </li>
            <li className="flex gap-3">
              <span className="font-semibold text-gray-900 min-w-fit">Datenübertragbarkeit (Art. 20 DSGVO):</span>
              <span>Sie haben das Recht, Ihre Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten.</span>
            </li>
            <li className="flex gap-3">
              <span className="font-semibold text-gray-900 min-w-fit">Widerspruch (Art. 21 DSGVO):</span>
              <span>Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Sie betreffender Daten Widerspruch einzulegen.</span>
            </li>
            <li className="flex gap-3">
              <span className="font-semibold text-gray-900 min-w-fit">Widerruf (Art. 7 Abs. 3 DSGVO):</span>
              <span>Wenn die Verarbeitung auf Ihrer Einwilligung beruht, haben Sie das Recht, diese jederzeit zu widerrufen.</span>
            </li>
          </ul>
          <p className="text-gray-600 leading-relaxed mt-4">
            Zur Ausübung Ihrer Rechte wenden Sie sich bitte an:{' '}
            <a href="mailto:app@merian.ai" className="text-teal-700 hover:underline">app@merian.ai</a>
          </p>
        </section>

        {/* 7. Beschwerderecht */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-gray-900 mb-4">7. Beschwerderecht bei der Aufsichtsbehörde</h2>
          <p className="text-gray-600 leading-relaxed">
            Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs steht Ihnen das Recht auf Beschwerde bei einer Datenschutz-Aufsichtsbehörde zu, wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden personenbezogenen Daten gegen die DSGVO verstößt. Die zuständige Aufsichtsbehörde richtet sich nach Ihrem Wohnort, Arbeitsort oder dem Ort des mutmaßlichen Verstoßes.
          </p>
        </section>

        {/* 8. Aktualität */}
        <section className="mb-10">
          <h2 className="text-xl font-bold text-gray-900 mb-4">8. Aktualität und Änderung dieser Datenschutzerklärung</h2>
          <p className="text-gray-600 leading-relaxed">
            Diese Datenschutzerklärung ist aktuell gültig und hat den Stand 21. August 2026. Durch die Weiterentwicklung unserer Website und Angebote oder aufgrund geänderter gesetzlicher beziehungsweise behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern. Die jeweils aktuelle Datenschutzerklärung kann jederzeit auf dieser Seite abgerufen werden.
          </p>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-8">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} Merian.ai &ndash; LocNet GmbH</p>
        </div>
      </footer>
    </div>
  );
}
